import { useContext, useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { PostAPI } from '../../../ApiServices/ApiServices';
import AppContext from '../../../Context/AppContext';
import Assets from '../../../Assets/Assets';
import { toast } from 'react-toastify';
import './Login.css';
const Login = () => {
    const navigate = useNavigate();
    const { user, setUser } = useContext(AppContext);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [errors, setErrors] = useState({});
    const [eyeOpen, setEyeOpen] = useState(false);

    // Form validation
    const validate = () => {
        let valid = true;
        let newErrors = {};
        if (!email) {
            newErrors.email = "Email is required";
            valid = false;
        }
        if (!password) {
            newErrors.password = "Password is required";
            valid = false;
        }
        setErrors(newErrors);
        return valid;
    };
  const signIn = async () => {
  if (!validate()) return; // Exit if validation fails

  try {
    const url = "/auth/doctor/login";
    const data = {
      email,
      password,
    };

    // Call your PostAPI helper
    console.log("Logging in with:", data);
PostAPI({ url, data }, async (res) => {
  console.log("API response:", res);
      if (res?.success) {
        const token = res?.response?.access_token;
        const refreshToken = res?.response?.refresh_token;
        const doctorData = res?.response?.doctorData;

        // ✅ Store tokens securely
        localStorage.setItem("token", token);
        localStorage.setItem("refreshToken", refreshToken);
        localStorage.setItem("loggedIn", "true");
        localStorage.setItem("subscribed", "false");

        // ✅ Update global user state (if using reducer/context)
        setUser({ type: "login", loginInfo: doctorData });

        // ✅ Optional: store user info if needed
        localStorage.setItem("doctorData", JSON.stringify(doctorData));
            console.log("111111111111111111111",token);
            console.log("22222222222222222",refreshToken);
            console.log("3333333333333333333",doctorData);
                        
            
        // ✅ Success notification
        toast.success(res?.message || "Login successful!");

        // ✅ Redirect user
        if (doctorData?.profile_status) {
        navigate("/profile");
        } else {
        navigate("/");
        }
      } else {
        // ❌ API responded but login failed
        toast.error(res?.extendedMessage || "Invalid credentials. Please try again.");
      }
    });
  } catch (error) {
    console.error("Error during login:", error);
    toast.error("Something went wrong. Please try again later.");
  }
};

    return (
        <div className="login-form container">
            <div className="right-content">
                <p className="wel-content">
                    <span className="color-txt">Hello! there,</span> Welcome Back
                </p>
                <h4 className="form-head">Login</h4>
            </div>
            <div className="form-box">
                <Form>
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                            type="email"
                            placeholder="Enter Email ID here"
                            className='login-input'
                            name="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                        {errors.email && <div className="error-text">{errors.email}</div>}
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="formBasicPassword">
                        <Form.Label>Password</Form.Label>
                        <div className='eye-setup'>
                            <Form.Control type={eyeOpen ? 'text' : 'password'}
                                placeholder="Enter Password here"
                                className='login-input'
                                name="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                            {errors.password && <div className="error-text">{errors.password}</div>}
                            <img src={eyeOpen ? Assets.eyeOpen : Assets.eyeClose} alt="eye-image" className='eye-img' onClick={() => setEyeOpen(!eyeOpen)} />
                        </div>
                        {/* <Form.Control
                            type="password"
                            placeholder="Enter Password here"
                            name="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                        {errors.password && <div className="error-text">{errors.password}</div>} */}
                    </Form.Group>
                    <small className="forgot-text">
                        <Link to={'/forgotpassword'}>Forgot Password?</Link>
                    </small>
                    <Button variant="primary" onClick={signIn}>
                        Sign in
                    </Button>
                    <div className="signup-link">   
                       New User? <Link to={'/signup'}>Sign Up</Link>
                        </div>
                </Form>
                    
            </div>
        </div>
    );
};

export default Login;
